// services/inscriptionApi.ts
import axios from "axios";
import { message } from "antd";
import { notification } from "antd";
export interface RegisterPatientPayload {
  fullName: string;
  birthDate: string;
  gender: string;
  password: string;
  phoneNumber: string;
  enterpriseId: string | null;
}
export interface InviteResponse {
  // adapt to what the API returns
  success: boolean;
  message?: string;
  data?: any;
}
export interface SaveNewUserPayload {
  phoneNumber: string;
  name: string;
  codeSource: string;
  enterpriseId?: number;
}

export const inscriptionApi = {


async sendVerificationCode(phoneNumber: string): Promise<{ token: string; otp?: string }> {
  if (!phoneNumber || phoneNumber.length < 8) {
    notification.error({
      message: "Erreur",
      description: `Numéro de téléphone invalide`,
      placement: "topRight",
    });
    throw new Error("Invalid phone number");
  }

  try {
    const response = await axios.post(
      "https://api.yatamedical.info/auth/public/send-otp",
      { phoneNumber }
    );

    if (response.status !== 200) {
      throw new Error("OTP not sent");
    }

    const token = response?.data?.token;
    if (!token) {
      throw new Error("OTP token missing");
    }

    const actualOTP = response?.data?.message ;


    notification.success({
      message: "Succès",
      description: `Code OTP envoyé à ${phoneNumber}`,
      placement: "topRight",
    });

    return { token, otp: actualOTP };
  } catch (error: any) {
    const errorMessage = error?.response?.data;
    // notification.error({
    //   message: "Error",
    //   description: `${errorMessage}`,
    //   placement: "topRight",
    // });
    throw error;
  }
},


  async verifyOtpCode(token: string, code: string): Promise<boolean> {
    if (!token) {
      message.error("Token manquant pour la vérification OTP.");
      return false;
    }

    try {
      const response = await axios.post(
        "https://api.yatamedical.info/auth/public/verify-otp",
        {
          token: token,
          codeSms: code,
        }
      );

      if (response?.data) {
        // message.success("OTP Verified");
        notification.success({
          message: "Succès",
          description: `OTP Verified`,
          placement: "topRight",
        });
        return true;
      } else {
        // message.error("Invalid OTP");
        notification.error({
          message: "Error",
          description: `Invalid OTP`,
          placement: "topRight",
        });
        return false;
      }
    } catch (error: any) {
      const errorMessage =
        error?.response?.data?.message || "OTP verification failed";
      // message.error(errorMessage);
      notification.error({
        message: "Error",
        description: `${errorMessage}`,
        placement: "topRight",
      });
      return false;
    }
  },
  async saveNewUser(
    phoneNumber: string,
    name: string,
    codeSource: string,
    enterpriseId?: number
  ): Promise<InviteResponse> {
    const payload: SaveNewUserPayload = {
      phoneNumber,
      name,
      codeSource,
    };
    if (enterpriseId !== 0) {
      payload.enterpriseId = enterpriseId;
    }
    try {
      const res = await fetch(
        `https://api.yatamedical.info/api/invite/save-newuser`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      if (!res.ok) {
        const text = await res.text();
        throw new Error(`API error ${res.status}: ${text || res.statusText}`);
      }
      console.log("response from invite", res);
      const json = await res.json();
      return {
        success: true,
        data: json,
      };
    } catch (err: any) {
      return {
        success: false,
        message: err.message || "Unknown error",
      };
    }
  },
  async registerPatient(payload: RegisterPatientPayload): Promise<void> {
    try {
      const response = await axios.post(
        "https://api.yatamedical.info/public/patients",
        payload
      );

      if (response.status === 201 || response.status === 200) {
        // message.success("Patient enregistré avec succès !");
        notification.success({
          message: "Succès",
          description: `Patient enregistré avec succès !`,
          placement: "topRight",
        });
      }

      const code = localStorage.getItem("code");
      const entrepriseIdStr = localStorage.getItem("entrepriseId");

      if (!code) {
        message.error("Code manquant.");
        return;
      }
      let entrepriseId = 0;
      if (entrepriseIdStr) {
        entrepriseId = parseInt(entrepriseIdStr, 10);
      }

      const inviteRes = await inscriptionApi.saveNewUser(
        payload.phoneNumber,
        payload.fullName,
        code,
        entrepriseId
      );
    } catch (error: any) {
      const errorMessage =
        error?.response?.data?.message ||
        "Échec de l'enregistrement du patient";
      message.error(errorMessage);
      throw error;
    }
  },

  
async sendEmailOTP(email: string, phoneNumber: string, otp: string) {
  try {
    const response = await axios.post(
      "https://api.yatamedical.info/auth/public/send-otp-via-email",
      {
        email,
        phoneNumber,
        otp,
      }
    );

    if (!response.data) {
      throw new Error("Failed to send email OTP");
    }

    // notification.success({
    //   message: "Succès",
    //   description: `Code OTP envoyé à l'adresse ${email}`,
    //   placement: "topRight",
    // });

    return response.data;
  } catch (error: any) {
    const errorMessage =
      error?.response?.data?.message || "Erreur lors de l'envoi de l'email OTP";

    notification.error({
      message: "Erreur",
      description: errorMessage,
      placement: "topRight",
    });

    throw error;
  }
}

};
